

























import { onMounted, defineComponent } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import useBreakpoints from '@getaccept/lib-shared/src/composables/breakpoints.composable';
import { TooltipPlacement } from '@getaccept/lib-shared/src/enums/tooltip-placement';
import { useSidebarStore } from './store/sidebar.store';

export default defineComponent({
  setup() {
    const { isXSmallScreen, isXXSmallScreen } = useBreakpoints();
    const sidebarStore = useSidebarStore();

    const { setCompact, toggleSideBar } = sidebarStore;
    const { compact } = storeToRefs(sidebarStore);

    const setDefaultMenuMode = () => {
      if (isXSmallScreen.value || isXXSmallScreen.value) {
        setCompact(true);
      }
    };

    onMounted(() => {
      setDefaultMenuMode();
      window.addEventListener('resize', setDefaultMenuMode);
    });

    return {
      compact,
      toggleSideBar,
      TooltipPlacement,
    };
  },
});
